{
  "version": 1,
  "asset_id": "96d3b281-5215-4f96-b2d7-95e3f4c8f2b2",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/96d3b281-5215-4f96-b2d7-95e3f4c8f2b2/hipay.png",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/96d3b281-5215-4f96-b2d7-95e3f4c8f2b2/hipay.png",
  "original_filename": "hipay.png",
  "size": 47076,
  "content_type": "image/png",
  "created_at": "2026-08-30T15:12:03Z"
}
